import React, {useState} from "react";
import {
    InfoWindow,
    Marker,
  } from "react-google-maps";
import { Button } from "react-bootstrap";
import Config from "services/config/config";
  
  const MarkerWithInfoBox = ({site}) => {
    const [isOpen, setIsOpen] = useState(false);
    const onToggleOpen = () =>  setIsOpen(!isOpen) 
    const navToDirection = (lat,lng) => {
        // If it's an iPhone..
        if( (navigator.platform.indexOf("iPhone") !== -1) 
            || (navigator.platform.indexOf("iPod") !== -1)
            || (navigator.platform.indexOf("iPad") !== -1))
             window.open(`${Config.googleAPI.iosMapNavDir}${lat},${lng}`);
        else
             window.open(`${Config.googleAPI.AndroidMapNavDir}${lat},${lng}`);
    }
    return (
        <Marker
            onClick={onToggleOpen}
            position={{ lat: Number(site.latitude), lng: Number(site.longitude) }}
        >
            {isOpen && <InfoWindow onCloseClick={onToggleOpen}>
                <div className="address-container">
                    <h5>{site.site_name}</h5>
                    <p>{site.site_address}</p>
                    <div className="navigateDirBox">
                        <Button onClick={()=>navToDirection(site.latitude, site.longitude)}>Get Directions</Button>
                    </div>
                </div>
            </InfoWindow>}
        </Marker>
    )}

  export default MarkerWithInfoBox;